import { render, staticRenderFns } from "./App.vue?vue&type=template&id=b57fe3ea&"
import script from "./App.vue?vue&type=script&lang=ts&"
export * from "./App.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sush/Virtual/cublic-form-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b57fe3ea')) {
      api.createRecord('b57fe3ea', component.options)
    } else {
      api.reload('b57fe3ea', component.options)
    }
    module.hot.accept("./App.vue?vue&type=template&id=b57fe3ea&", function () {
      api.rerender('b57fe3ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resource/component/form/App.vue"
export default component.exports